module.exports = __webpack_public_path__ + "img/icones_cypress-1.04b1b28c.png";